import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function ValueStackSection() {
  const contents = ['Desafíos familiares divertidos y económicos.', 'Momentos guiados de conexión emocional.', 'Espacios para escribir y guardar recuerdos eternos.'];
  return <section className="py-10 bg-white" data-id="element-150" data-mp="1he9qlz57x1ja">
      <div className="container mx-auto px-4" data-id="element-151" data-mp="1hfbej47c1iif">
        <FadeIn data-id="element-152" data-mp="tmukrwe8g23a">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-8" data-id="element-153" data-mp="toffbm0jrl15">
            ¿QUÉ VAS A RECIBIR EXACTAMENTE?
          </h2>
        </FadeIn>

        <div className="flex flex-col lg:flex-row items-center gap-8 max-w-6xl mx-auto" data-id="element-154" data-mp="12o2es29pugrk">
          <FadeIn direction="right" className="w-full lg:w-1/2" data-id="element-155" data-mp="ymqsa5m52bnl">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-brand-100" data-id="element-156" data-mp="ylfm5z580rtb">
              <img src="https://cdn.magicpatterns.com/uploads/gdoNaevVERZnpGkuzwxwbb/WhatsApp_Image_2026-04-05_at_18.28.17_(1).jpg" alt="Pack 100 Citas con mi Hijo e Hija" className="w-full h-auto object-cover" data-id="element-157" data-mp="2e5kemqo6ew8t" />
              <div className="absolute top-4 right-4 bg-brand-500 text-white font-bold py-1 px-3 rounded-full text-sm shadow-lg" data-id="element-158" data-mp="1saqo0pg3zaq2">
                Formato Digital PDF
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" className="w-full lg:w-1/2" data-id="element-159" data-mp="21anf0xpz0loa">
            <div className="space-y-5" data-id="element-160" data-mp="14niflyndvljt">
              <div data-id="element-161" data-mp="14ke7iq6ss5nv">
                <h3 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3" data-id="element-162" data-mp="18nsxo9oga2f1">
                  <span className="bg-brand-100 text-brand-700 w-10 h-10 rounded-full flex items-center justify-center text-xl" data-id="element-163" data-mp="1dn5g8i8agnbt">
                    1
                  </span>
                  Libro Digital "100 Citas con mi Hija" 👧
                </h3>
              </div>

              <div data-id="element-164" data-mp="kwf3dy6qnwrf">
                <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3" data-id="element-165" data-mp="pxkxo0g1rs32">
                  <span className="bg-brand-100 text-brand-700 w-10 h-10 rounded-full flex items-center justify-center text-xl" data-id="element-166" data-mp="1t8i9c0prvvzc">
                    2
                  </span>
                  Libro Digital "100 Citas con mi Hijo" 👦
                </h3>
              </div>

              <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100" data-id="element-167" data-mp="222wnu12hb2he">
                <h4 className="font-bold text-slate-900 text-lg mb-4" data-id="element-168" data-mp="1xzqkp2anxrf5">
                  Contenido de cada libro:
                </h4>
                <ul className="space-y-4" data-id="element-169" data-mp="15ajcfblepngp">
                  {contents.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-170" data-mp="1jaaw9sylty2m" data-mpi={index}>
                      <CheckCircle2 className="w-6 h-6 text-brand-500 shrink-0 mt-0.5" data-id="element-171" data-mp="1jbm1zybm1fwd" />
                      <span className="text-slate-700 text-lg" data-id="element-172" data-mp="1e9oayhwyxgsv">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}